
import {HTTP_REST_URLS} from "../config/urls";

export const useAllPrograms = (headers = {}, query = '') => new Promise((res, req) => {

    const url = HTTP_REST_URLS.GET_ALL_PROGRAMS + query

    let responseObject ={};


    fetch(url, {
        method: 'GET',
        headers: headers
    })
        .then((res) => (res.json()))
        .then(async(response) => {

            if(!response.error)
            {

                const dataList = Array.isArray(response?.data)? response?.data : []

                responseObject['data'] = dataList;
                responseObject['total_data'] = response?.total_data
                
                res(responseObject)
            //     const { programs } = response;
            //     const programList = programs.program_list
            //     const bundleList = programs?.bundle_list;

            //     const result = [...programList, ...bundleList]

            //     if(hasBundle)
            //     {
            //         res(result)
            //     }
            //     else
            //     {
            //         if(Array.isArray(programList))
            //         {
            //             res(programList)
            //         }
            //     }
            }
            else
            {
                responseObject['data'] = [];
                res(responseObject)
            }

        })

})
